import { useState } from 'react';
import { faqItems, FaqItem } from '@/mocks/faq';

function FaqCard({ item, isOpen, onToggle }: { item: FaqItem; isOpen: boolean; onToggle: () => void }) {
  return (
    <div className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50">
      <button
        className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
          {item.question}
        </span>
        <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500"></i>
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
          {item.answer}
        </div>
      </div>
    </div>
  );
}

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
            常见问题
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            关于在线建站的常见疑问，这里都有答案。如果还有问题，欢迎随时联系我们。
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item) => (
            <FaqCard
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() => handleToggle(item.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}